import React from 'react'
import { Views } from '../../views'

const Error404 = () => {
    const { Error404 } = Views
    return <Error404 />
}

export default Error404